import { Card, Box, Button, CardContent, Grid, Table, TableBody, TableHead, TableRow } from '@mui/material'
import TableHeadCell from 'components/TableHeadCell'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useBasePath } from 'components/Providers'
import RoomItem from './ListItem'
import { hasFullPermission } from 'store'

export default function RoomList() {
  const rooms = useSelector(state => state.settings.room.list)
  const { t } = useTranslation()
  const navigate = useNavigate()
  const basePath = useBasePath()
  const hasReadWritePermission = hasFullPermission('setting.room')

  return (
    <Box data-component="RoomList" sx={{ minHeight: '50%' }}>
      {hasReadWritePermission && (
        <Box sx={{ pt: 2, display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={() => navigate(`${basePath}/new`)}
          >
            {t('Add Room')}
          </Button>
        </Box>
      )}
      <Grid container spacing={1} sx={{ mt: 0 }}>
        <Grid item sm={12} xs={12} md={12}>
          <Card elevation={0} sx={{ minHeight: '600px' }}>
            <CardContent sx={{ pr: 0, pl: 0 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableHeadCell sx={{ width: '90%' }}>{t('Room Name')}</TableHeadCell>
                    {hasReadWritePermission && <TableHeadCell sx={{ width: '10%' }}>{t('Actions')}</TableHeadCell>}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rooms?.map(item => {
                    return <RoomItem key={item.id || item.uid} room={item} hasReadWritePermission={hasReadWritePermission} />
                  })}
                </TableBody>
              </Table>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  )
}
